module.exports = __webpack_public_path__ + "assets/7295d40d61e5b0d8e416793617649a7a.png";